export default __webpack_public_path__ + "static/media/spaceDefault.69492ad2.png";